// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { BulkDeleteReportItemsData, BulkDeleteReportItemsErrors, BulkDeleteReportItemsResponses, CheckVatValidData, CheckVatValidResponses, CopyReportItemData, CopyReportItemErrors, CopyReportItemResponses, CreateReportItemData, CreateReportItemErrors, CreateReportItemResponses, CreateReportVersionData, CreateReportVersionErrors, CreateReportVersionResponses, CreateSessionData, CreateSessionResponses, DownloadReportVersionXlsxData, DownloadReportVersionXlsxErrors, DownloadReportVersionXlsxResponses, DownloadReportVersionXmlData, DownloadReportVersionXmlErrors, DownloadReportVersionXmlResponses, FindBusinessEntitiesData, FindBusinessEntitiesErrors, FindBusinessEntitiesResponses, FindReportData, FindReportErrors, FindReportResponses, GetAllCombinedNomenclaturesData, GetAllCombinedNomenclaturesErrors, GetAllCombinedNomenclaturesResponses, GetCombinedNomenclatureByCodeData, GetCombinedNomenclatureByCodeErrors, GetCombinedNomenclatureByCodeResponses, GetCombinedNomenclatureUnitOfMeasureData, GetCombinedNomenclatureUnitOfMeasureErrors, GetCombinedNomenclatureUnitOfMeasureResponses, GetCountriesData, GetCountriesErrors, GetCountriesResponses, GetCurrentBusinessEntityData, GetCurrentBusinessEntityErrors, GetCurrentBusinessEntityResponses, GetDeliveryTermsData, GetDeliveryTermsErrors, GetDeliveryTermsResponses, GetModeOfTransportsData, GetModeOfTransportsErrors, GetModeOfTransportsResponses, GetNatureOfTransactionsData, GetNatureOfTransactionsErrors, GetNatureOfTransactionsResponses, GetNotificationsData, GetNotificationsResponses, GetRegionsData, GetRegionsErrors, GetRegionsResponses, GetReportByIdData, GetReportByIdErrors, GetReportByIdResponses, GetReportErrorsData, GetReportErrorsErrors, GetReportErrorsResponses, GetReportItemByIdData, GetReportItemByIdErrors, GetReportItemByIdResponses, GetReportStatusesData, GetReportStatusesErrors, GetReportStatusesResponses, GetReportSubmissionStatusData, GetReportSubmissionStatusErrors, GetReportSubmissionStatusResponses, GetReportSummariesData, GetReportSummariesErrors, GetReportSummariesResponses, GetReportSummaryStatusesData, GetReportSummaryStatusesErrors, GetReportSummaryStatusesResponses, GetReportVersionByIdData, GetReportVersionByIdErrors, GetReportVersionByIdResponses, GetReportVersionHeaderData, GetReportVersionHeaderErrors, GetReportVersionHeaderResponses, GetReportVersionOperationStatusData, GetReportVersionOperationStatusErrors, GetReportVersionOperationStatusResponses, GetSubmissionMethodsData, GetSubmissionMethodsErrors, GetSubmissionMethodsResponses, GetTradeDirectionsData, GetTradeDirectionsErrors, GetTradeDirectionsResponses, GetUnitOfMeasuresData, GetUnitOfMeasuresErrors, GetUnitOfMeasuresResponses, GetUnreadNotificationsCountData, GetUnreadNotificationsCountResponses, InvalidateSessionData, InvalidateSessionResponses, MarkNotificationAsReadData, MarkNotificationAsReadErrors, MarkNotificationAsReadResponses, SubmitReportVersionData, SubmitReportVersionErrors, SubmitReportVersionResponses, UpdateEmailNotificationFlagData, UpdateEmailNotificationFlagErrors, UpdateEmailNotificationFlagResponses, UpdateReportItemData, UpdateReportItemErrors, UpdateReportItemResponses, UpdateReportVersionHeaderData, UpdateReportVersionHeaderErrors, UpdateReportVersionHeaderResponses, UpdateReportVersionZeroTradeData, UpdateReportVersionZeroTradeErrors, UpdateReportVersionZeroTradeResponses, UploadReportSubmissionXlsxData, UploadReportSubmissionXlsxErrors, UploadReportSubmissionXlsxResponses, UploadReportSubmissionXmlData, UploadReportSubmissionXmlErrors, UploadReportSubmissionXmlResponses, ValidateReportVersionData, ValidateReportVersionErrors, ValidateReportVersionResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Invalidate a backend session
 */
export const invalidateSession = <ThrowOnError extends boolean = false>(options?: Options<InvalidateSessionData, ThrowOnError>) => (options?.client ?? client).delete<InvalidateSessionResponses, unknown, ThrowOnError>({ url: '/ui/session', ...options });

/**
 * Initialize a backend session for a represented entity
 */
export const createSession = <ThrowOnError extends boolean = false>(options: Options<CreateSessionData, ThrowOnError>) => (options.client ?? client).post<CreateSessionResponses, unknown, ThrowOnError>({
    url: '/ui/session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a specific report with its versions by ID
 *
 * Returns the complete information for a report, including a list of all its associated versions.
 */
export const getReportById = <ThrowOnError extends boolean = false>(options: Options<GetReportByIdData, ThrowOnError>) => (options.client ?? client).get<GetReportByIdResponses, GetReportByIdErrors, ThrowOnError>({ url: '/ui/reports/{reportId}', ...options });

/**
 * Find a report by period and trade direction.
 */
export const findReport = <ThrowOnError extends boolean = false>(options: Options<FindReportData, ThrowOnError>) => (options.client ?? client).get<FindReportResponses, FindReportErrors, ThrowOnError>({ url: '/ui/reports/search', ...options });

/**
 * Get report summaries for a specific business entity in a time range
 *
 * Returns a list of report summaries for a business entity in a time range, considering whether the trade direction is import or export.
 */
export const getReportSummaries = <ThrowOnError extends boolean = false>(options: Options<GetReportSummariesData, ThrowOnError>) => (options.client ?? client).get<GetReportSummariesResponses, GetReportSummariesErrors, ThrowOnError>({ url: '/ui/reports/summaries', ...options });

/**
 * Create a new report version.
 *
 * Creates a new version for the specified reporting period from scratch, or from an existing version.
 */
export const createReportVersion = <ThrowOnError extends boolean = false>(options: Options<CreateReportVersionData, ThrowOnError>) => (options.client ?? client).post<CreateReportVersionResponses, CreateReportVersionErrors, ThrowOnError>({
    url: '/ui/reports/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single report version by id.
 *
 * Returns a report version, including the report item list for the version.
 */
export const getReportVersionById = <ThrowOnError extends boolean = false>(options: Options<GetReportVersionByIdData, ThrowOnError>) => (options.client ?? client).get<GetReportVersionByIdResponses, GetReportVersionByIdErrors, ThrowOnError>({ url: '/ui/reports/versions/{versionId}', ...options });

/**
 * Get the header information for a report version.
 *
 * Gets the vat payer, registration, etc. info for a specific report version by ID.
 */
export const getReportVersionHeader = <ThrowOnError extends boolean = false>(options: Options<GetReportVersionHeaderData, ThrowOnError>) => (options.client ?? client).get<GetReportVersionHeaderResponses, GetReportVersionHeaderErrors, ThrowOnError>({ url: '/ui/reports/versions/{versionId}/header', ...options });

/**
 * Update the header information for a report version.
 *
 * Updates the vat payer, registration, etc. info for a specific report version by ID.
 */
export const updateReportVersionHeader = <ThrowOnError extends boolean = false>(options: Options<UpdateReportVersionHeaderData, ThrowOnError>) => (options.client ?? client).post<UpdateReportVersionHeaderResponses, UpdateReportVersionHeaderErrors, ThrowOnError>({
    url: '/ui/reports/versions/{versionId}/header',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update the zero trade indicator for a report version.
 *
 * Updates only the zero trade indicator for a specific report version by ID.
 */
export const updateReportVersionZeroTrade = <ThrowOnError extends boolean = false>(options: Options<UpdateReportVersionZeroTradeData, ThrowOnError>) => (options.client ?? client).put<UpdateReportVersionZeroTradeResponses, UpdateReportVersionZeroTradeErrors, ThrowOnError>({
    url: '/ui/reports/versions/{versionId}/zero-trade',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get report errors for a specific report.
 *
 * Return both report level errors and all item level errors for a specific report version ID.
 */
export const getReportErrors = <ThrowOnError extends boolean = false>(options: Options<GetReportErrorsData, ThrowOnError>) => (options.client ?? client).get<GetReportErrorsResponses, GetReportErrorsErrors, ThrowOnError>({ url: '/ui/reports/versions/{versionId}/errors', ...options });

/**
 * Validate report version.
 */
export const validateReportVersion = <ThrowOnError extends boolean = false>(options: Options<ValidateReportVersionData, ThrowOnError>) => (options.client ?? client).post<ValidateReportVersionResponses, ValidateReportVersionErrors, ThrowOnError>({ url: '/ui/reports/versions/{versionId}/validate', ...options });

/**
 * Submit report version.
 */
export const submitReportVersion = <ThrowOnError extends boolean = false>(options: Options<SubmitReportVersionData, ThrowOnError>) => (options.client ?? client).post<SubmitReportVersionResponses, SubmitReportVersionErrors, ThrowOnError>({ url: '/ui/reports/versions/{versionId}/submit', ...options });

/**
 * Get processing status of a validate/submit operation on a report version.
 */
export const getReportVersionOperationStatus = <ThrowOnError extends boolean = false>(options: Options<GetReportVersionOperationStatusData, ThrowOnError>) => (options.client ?? client).get<GetReportVersionOperationStatusResponses, GetReportVersionOperationStatusErrors, ThrowOnError>({ url: '/ui/reports/versions/{versionId}/operation-status', ...options });

/**
 * Create a new report item.
 */
export const createReportItem = <ThrowOnError extends boolean = false>(options: Options<CreateReportItemData, ThrowOnError>) => (options.client ?? client).post<CreateReportItemResponses, CreateReportItemErrors, ThrowOnError>({
    url: '/ui/reports/versions/{versionId}/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a specific report item by ID.
 */
export const getReportItemById = <ThrowOnError extends boolean = false>(options: Options<GetReportItemByIdData, ThrowOnError>) => (options.client ?? client).get<GetReportItemByIdResponses, GetReportItemByIdErrors, ThrowOnError>({ url: '/ui/reports/versions/{versionId}/items/{itemId}', ...options });

/**
 * Update an existing report item.
 */
export const updateReportItem = <ThrowOnError extends boolean = false>(options: Options<UpdateReportItemData, ThrowOnError>) => (options.client ?? client).put<UpdateReportItemResponses, UpdateReportItemErrors, ThrowOnError>({
    url: '/ui/reports/versions/{versionId}/items/{itemId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete multiple report items.
 */
export const bulkDeleteReportItems = <ThrowOnError extends boolean = false>(options: Options<BulkDeleteReportItemsData, ThrowOnError>) => (options.client ?? client).post<BulkDeleteReportItemsResponses, BulkDeleteReportItemsErrors, ThrowOnError>({
    url: '/ui/reports/versions/{versionId}/items/bulk-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Copy a report item.
 */
export const copyReportItem = <ThrowOnError extends boolean = false>(options: Options<CopyReportItemData, ThrowOnError>) => (options.client ?? client).post<CopyReportItemResponses, CopyReportItemErrors, ThrowOnError>({ url: '/ui/reports/versions/{versionId}/items/{itemId}/copy', ...options });

/**
 * Download report version as a xml file.
 *
 * Downloads the report version with all the report items as either a xml file.
 */
export const downloadReportVersionXml = <ThrowOnError extends boolean = false>(options: Options<DownloadReportVersionXmlData, ThrowOnError>) => (options.client ?? client).get<DownloadReportVersionXmlResponses, DownloadReportVersionXmlErrors, ThrowOnError>({ url: '/ui/reports/versions/{versionId}/download/xml', ...options });

/**
 * Download report version as a xlsx file.
 *
 * Downloads the report version with all the report items as either a xlsx file.
 */
export const downloadReportVersionXlsx = <ThrowOnError extends boolean = false>(options: Options<DownloadReportVersionXlsxData, ThrowOnError>) => (options.client ?? client).get<DownloadReportVersionXlsxResponses, DownloadReportVersionXlsxErrors, ThrowOnError>({ url: '/ui/reports/versions/{versionId}/download/xlsx', ...options });

/**
 * Uploads IntrastatReportSubmission.xml.
 */
export const uploadReportSubmissionXml = <ThrowOnError extends boolean = false>(options: Options<UploadReportSubmissionXmlData, ThrowOnError>) => (options.client ?? client).post<UploadReportSubmissionXmlResponses, UploadReportSubmissionXmlErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/ui/reports/upload/xml',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Uploads IntrastatReportSubmission.xlsx.
 */
export const uploadReportSubmissionXlsx = <ThrowOnError extends boolean = false>(options: Options<UploadReportSubmissionXlsxData, ThrowOnError>) => (options.client ?? client).post<UploadReportSubmissionXlsxResponses, UploadReportSubmissionXlsxErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/ui/reports/upload/xlsx',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get processing status of a report submission.
 */
export const getReportSubmissionStatus = <ThrowOnError extends boolean = false>(options: Options<GetReportSubmissionStatusData, ThrowOnError>) => (options.client ?? client).get<GetReportSubmissionStatusResponses, GetReportSubmissionStatusErrors, ThrowOnError>({ url: '/ui/reports/uploads/{submissionId}', ...options });

/**
 * Get a list of all combined nomenclatures.
 */
export const getAllCombinedNomenclatures = <ThrowOnError extends boolean = false>(options?: Options<GetAllCombinedNomenclaturesData, ThrowOnError>) => (options?.client ?? client).get<GetAllCombinedNomenclaturesResponses, GetAllCombinedNomenclaturesErrors, ThrowOnError>({ url: '/ui/classifiers/combined-nomenclatures', ...options });

/**
 * Get a specific combined nomenclature by code.
 */
export const getCombinedNomenclatureByCode = <ThrowOnError extends boolean = false>(options: Options<GetCombinedNomenclatureByCodeData, ThrowOnError>) => (options.client ?? client).get<GetCombinedNomenclatureByCodeResponses, GetCombinedNomenclatureByCodeErrors, ThrowOnError>({ url: '/ui/classifiers/combined-nomenclatures/{code}', ...options });

/**
 * Get unit of measure code for a specific combined nomenclature.
 */
export const getCombinedNomenclatureUnitOfMeasure = <ThrowOnError extends boolean = false>(options: Options<GetCombinedNomenclatureUnitOfMeasureData, ThrowOnError>) => (options.client ?? client).get<GetCombinedNomenclatureUnitOfMeasureResponses, GetCombinedNomenclatureUnitOfMeasureErrors, ThrowOnError>({ url: '/ui/classifiers/combined-nomenclatures/{code}/unit-of-measure', ...options });

/**
 * Get a list of all valid regions.
 */
export const getRegions = <ThrowOnError extends boolean = false>(options?: Options<GetRegionsData, ThrowOnError>) => (options?.client ?? client).get<GetRegionsResponses, GetRegionsErrors, ThrowOnError>({ url: '/ui/classifiers/regions', ...options });

/**
 * Get a list of all valid nature of transactions.
 */
export const getNatureOfTransactions = <ThrowOnError extends boolean = false>(options?: Options<GetNatureOfTransactionsData, ThrowOnError>) => (options?.client ?? client).get<GetNatureOfTransactionsResponses, GetNatureOfTransactionsErrors, ThrowOnError>({ url: '/ui/classifiers/nature-of-transactions', ...options });

/**
 * Get a list of all valid delivery terms.
 */
export const getDeliveryTerms = <ThrowOnError extends boolean = false>(options?: Options<GetDeliveryTermsData, ThrowOnError>) => (options?.client ?? client).get<GetDeliveryTermsResponses, GetDeliveryTermsErrors, ThrowOnError>({ url: '/ui/classifiers/delivery-terms', ...options });

/**
 * Get a list of all valid mode of transports.
 */
export const getModeOfTransports = <ThrowOnError extends boolean = false>(options?: Options<GetModeOfTransportsData, ThrowOnError>) => (options?.client ?? client).get<GetModeOfTransportsResponses, GetModeOfTransportsErrors, ThrowOnError>({ url: '/ui/classifiers/mode-of-transports', ...options });

/**
 * Get a list of all valid unit of measures.
 */
export const getUnitOfMeasures = <ThrowOnError extends boolean = false>(options?: Options<GetUnitOfMeasuresData, ThrowOnError>) => (options?.client ?? client).get<GetUnitOfMeasuresResponses, GetUnitOfMeasuresErrors, ThrowOnError>({ url: '/ui/classifiers/unit-of-measures', ...options });

/**
 * Get a list of all countries.
 */
export const getCountries = <ThrowOnError extends boolean = false>(options?: Options<GetCountriesData, ThrowOnError>) => (options?.client ?? client).get<GetCountriesResponses, GetCountriesErrors, ThrowOnError>({ url: '/ui/classifiers/countries', ...options });

/**
 * Get a list of all trade directions.
 */
export const getTradeDirections = <ThrowOnError extends boolean = false>(options?: Options<GetTradeDirectionsData, ThrowOnError>) => (options?.client ?? client).get<GetTradeDirectionsResponses, GetTradeDirectionsErrors, ThrowOnError>({ url: '/ui/classifiers/trade-directions', ...options });

/**
 * Get a list of all report statuses.
 */
export const getReportStatuses = <ThrowOnError extends boolean = false>(options?: Options<GetReportStatusesData, ThrowOnError>) => (options?.client ?? client).get<GetReportStatusesResponses, GetReportStatusesErrors, ThrowOnError>({ url: '/ui/classifiers/report-statuses', ...options });

/**
 * Get a list of all report summary statuses.
 */
export const getReportSummaryStatuses = <ThrowOnError extends boolean = false>(options?: Options<GetReportSummaryStatusesData, ThrowOnError>) => (options?.client ?? client).get<GetReportSummaryStatusesResponses, GetReportSummaryStatusesErrors, ThrowOnError>({ url: '/ui/classifiers/report-summary-statuses', ...options });

/**
 * Get a list of all submission methods.
 */
export const getSubmissionMethods = <ThrowOnError extends boolean = false>(options?: Options<GetSubmissionMethodsData, ThrowOnError>) => (options?.client ?? client).get<GetSubmissionMethodsResponses, GetSubmissionMethodsErrors, ThrowOnError>({ url: '/ui/classifiers/submission-methods', ...options });

/**
 * Get the logged in business entity profile information.
 */
export const getCurrentBusinessEntity = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentBusinessEntityData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentBusinessEntityResponses, GetCurrentBusinessEntityErrors, ThrowOnError>({ url: '/ui/business-entity', ...options });

/**
 * Find a business entity by code and type
 */
export const findBusinessEntities = <ThrowOnError extends boolean = false>(options: Options<FindBusinessEntitiesData, ThrowOnError>) => (options.client ?? client).post<FindBusinessEntitiesResponses, FindBusinessEntitiesErrors, ThrowOnError>({
    url: '/ui/business-entity/lookup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if a VAT number is valid in IDAIS.
 */
export const checkVatValid = <ThrowOnError extends boolean = false>(options: Options<CheckVatValidData, ThrowOnError>) => (options.client ?? client).get<CheckVatValidResponses, unknown, ThrowOnError>({ url: '/ui/business-entity/vat-check', ...options });

/**
 * Update business entity email notification flag.
 */
export const updateEmailNotificationFlag = <ThrowOnError extends boolean = false>(options: Options<UpdateEmailNotificationFlagData, ThrowOnError>) => (options.client ?? client).put<UpdateEmailNotificationFlagResponses, UpdateEmailNotificationFlagErrors, ThrowOnError>({ url: '/ui/business-entity/update-email-notification-flag', ...options });

/**
 * Get the number of unread email notifications for the current business entity.
 */
export const getUnreadNotificationsCount = <ThrowOnError extends boolean = false>(options?: Options<GetUnreadNotificationsCountData, ThrowOnError>) => (options?.client ?? client).get<GetUnreadNotificationsCountResponses, unknown, ThrowOnError>({ url: '/ui/notifications/unread-count', ...options });

/**
 * Get all email notifications for the current business entity with pagination.
 */
export const getNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsData, ThrowOnError>) => (options?.client ?? client).get<GetNotificationsResponses, unknown, ThrowOnError>({ url: '/ui/notifications', ...options });

/**
 * Mark an email notification as read.
 */
export const markNotificationAsRead = <ThrowOnError extends boolean = false>(options: Options<MarkNotificationAsReadData, ThrowOnError>) => (options.client ?? client).post<MarkNotificationAsReadResponses, MarkNotificationAsReadErrors, ThrowOnError>({ url: '/ui/notifications/{notificationId}/read', ...options });
